import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import raf from 'raf';
import errorBoundary from '@ifeng-fe/errorBoundary';

const adHeight = 60;

class PicTxt extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        txtShow: PropTypes.bool,
    };

    state = {
        xHeight: 0,
        maxY: 0,
        translateY: 0,
        initY: 0,
    };

    box = React.createRef();
    txt = React.createRef();

    componentDidMount() {
        const height = this.box.current.clientHeight;
        const xHeight = this.txt.current.clientHeight + adHeight;

        this.setState({
            xHeight,
            maxY: height,
            translateY: height,
            initY: height,
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.content.current !== prevProps.content.current) {
            const xHeight = this.txt.current.clientHeight + adHeight;

            const { maxY } = this.state;

            if (this.props.txtShow) {
                this.setState({
                    xHeight,
                    translateY: maxY,
                    initY: maxY,
                });
            } else {
                this.setState({
                    xHeight,
                });
            }
        }

        if (this.props.txtShow !== prevProps.txtShow) {
            if (this.props.txtShow) {
                this.upSlide();
            } else {
                this.downSlide();
            }
        }
    }

    upSlide = () => {
        const { maxY } = this.state;
        let { translateY } = this.state;

        const step = () => {
            translateY += 10;

            this.setState({
                translateY,
            });

            if (translateY >= maxY) {
                raf.cancel(step);

                this.setState({
                    translateY: maxY,
                    initY: maxY,
                });
            } else {
                raf(step);
            }
        };

        raf(step);
    };

    downSlide = () => {
        let { translateY } = this.state;

        const step = () => {
            translateY -= 10;

            this.setState({
                translateY,
            });

            if (translateY <= 0) {
                raf.cancel(step);

                this.setState({
                    translateY: 0,
                    initY: 0,
                });
            } else {
                raf(step);
            }
        };

        raf(step);
    };

    handleTouchStart = e => {
        const touch = e.touches[0];

        this.startX = touch.pageX;
        this.startY = touch.pageY;
        this.moveX = 0;
        this.moveY = 0;
    };

    handleTouchMove = e => {
        const { xHeight, maxY, initY } = this.state;
        const touch = e.touches[0];

        this.moveX = touch.pageX - this.startX;
        this.moveY = touch.pageY - this.startY;

        if (initY - this.moveY > xHeight) {
            return;
        } else if (initY - this.moveY < maxY) {
            return;
        } else {
            this.setState({
                translateY: initY - this.moveY,
                showFlag: false,
            });
        }
    };

    handleTouchCancel = () => {
        if (!this.moveY || this.moveY === 0) return;

        const { translateY } = this.state;

        this.setState({
            initY: translateY,
        });

        raf(this.step);
    };

    handleTouchEnd = () => {
        if (!this.moveY || this.moveY === 0) return;

        const { xHeight, maxY, translateY } = this.state;

        if (translateY > xHeight) {
            raf.cancel(this.step);

            this.setState({
                translateY: xHeight,
                initY: xHeight,
            });
        } else if (this.moveY > 0 && translateY < maxY) {
            raf.cancel(this.step);

            this.setState({
                translateY: maxY,
                initY: maxY,
            });
        } else {
            this.setState({
                initY: translateY,
            });

            raf(this.step);
        }
    };

    step = () => {
        if (!this.props.txtShow) {
            raf.cancel(this.step);

            this.setState({
                translateY: window.innerHeight,
                initY: window.innerHeight,
            });

            return;
        }

        const { xHeight, maxY } = this.state;
        let { translateY } = this.state;

        if (this.moveY < 0) {
            translateY += 5;
        } else {
            translateY -= 5;
        }

        this.setState({
            translateY,
        });

        if (this.moveY < 0 && translateY > xHeight) {
            raf.cancel(this.step);

            this.setState({
                translateY: xHeight,
                initY: xHeight,
            });
        } else if (this.moveY > 0 && translateY < maxY) {
            raf.cancel(this.step);

            this.setState({
                translateY: maxY,
                initY: maxY,
            });
        } else if (this.moveY === 0) {
            this.setState({
                initY: translateY,
            });
        } else {
            raf(this.step);
        }
    };

    setLocation = translateY => {
        return 'WebKitCSSMatrix' in window ? `translate3d(0, ${translateY}px, 0)` : `translate(0, ${translateY}px)`;
    };

    render() {
        const { maxY, translateY } = this.state;
        const {
            content: { current, title, image },
        } = this.props;

        const props = {
            style:
                maxY === 0
                    ? {}
                    : {
                          height: `${translateY}px`,
                      },
        };

        return (
            <div className={styles.bottom_box} {...props}>
                <div
                    className={styles.txt_box}
                    ref={this.box}
                    onTouchMove={this.handleTouchMove}
                    onTouchStart={this.handleTouchStart}
                    onTouchCancel={this.handleTouchCancel}
                    onTouchEnd={this.handleTouchEnd}>
                    <div className={styles.txt} ref={this.txt}>
                        <div className={styles.page}>
                            <span className={styles.current}>{current + 1}</span>
                            <span className={styles.line}>/</span>
                            <span className={styles.total}>{image.length}</span>
                        </div>
                        <ul>
                            <li>
                                <h2>{title}</h2>
                                <p>{image?.[current]?.description || ''}</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(PicTxt);
